
export enum actions {
  SET_LANGUAGE = 'SET_LANGUAGE'
}
